import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import {
  AirlinePreference,
  AirlinePreferenceKeys,
} from '@ag-common-lib/lib/models/utils/flight-preference.model';
import { Airlines, FlightInfoKeys, LookupBase, LookupKeys } from '@ag-common-lib/public-api';
import { AirlinePreferenceFormService } from './airline-preference-form.service';

@Component({
  selector: 'ag-edit-flight-preference-form',
  templateUrl: './airline-preference-form.component.html',
  styleUrl: './airline-preference-form.component.scss',
})
export class AirlinePreferenceFormComponent {
  @HostBinding('class') protected className = 'edit-flight-preference-form';

  @Input()
  set airlinePreference(data: Partial<AirlinePreference>) {
    this.formData = this.airlinePreferenceFormService.getFormData(data);
  }
  get airlinePreference() {
    return this.formData;
  }
  @Input() validationGroup: string;
  @Input() filteredAirlines: LookupBase[];
  @Input() isFirstChoiceDisabled: boolean = false;
  @Input() isSecondChoiceDisabled: boolean = false;
  @Output() updateFilteredAirlines = new EventEmitter(false);

  formData: Partial<AirlinePreference>;
  protected readonly LookupKeys = LookupKeys;
  protected readonly FlightInfoKeys = FlightInfoKeys;
  protected readonly Airlines = Airlines;
  protected readonly AirlinePreferenceKeys = AirlinePreferenceKeys;

  constructor(private airlinePreferenceFormService: AirlinePreferenceFormService) {}

  onPreferredAirlineValueChanged = e => {
    console.log('onPreferredAirlineValueChanged e ', e);
    this.updateFilteredAirlines.emit(true);
  };

  onCancelEdit = () => this.airlinePreferenceFormService.onCancelEdit();
}
